import { IAugmentedJQuery, IDirective, IScope, IAttributes, IDirectiveFactory } from "angular";
import { LazySrcWrapperController } from "./lazy-src-wrapper";

export class LazySrc implements IDirective {
  public restrict = "A";
  public require = "^?lazySrcWrapper";

  public link(scope: IScope, element: IAugmentedJQuery, attrs: IAttributes, ctrl: LazySrcWrapperController): void {
    attrs.$observe<string>("lazySrc", (imageSrc) => {
      if (ctrl && imageSrc) {
        ctrl.addImage(element[0]);

        element.on("$destroy", () => {
          ctrl.removeImage(element[0]);
        });
        return;
      }

      const elementSrc = element.attr("src");
      if (!imageSrc || elementSrc === imageSrc) {
        return;
      }

      attrs.$set("src", imageSrc);
    });
  }

  public static factory(): IDirectiveFactory {
    const directive = () => new LazySrc();
    directive.$inject = [];
    return directive;
  }
}
